module.exports = __webpack_public_path__ + "static/media/Taquitosbanano.7caa114e.jpg";